import { useAuth } from '../../../contexts/AuthContext';
import { securityApi } from '../services/securityApi';
import type { ForwardWiringQueueStatusResponse } from '../types/security';
import { usePollingResource } from './usePollingResource';

const DEFAULT_INTERVAL_MS = 15_000;

export function useForwardWiringQueueStatus(
  recentRowsLimit = 10,
  intervalMs: number = DEFAULT_INTERVAL_MS,
) {
  const { authFetch } = useAuth();
  return usePollingResource<ForwardWiringQueueStatusResponse>({
    fetcher: () => securityApi.getForwardWiringQueueStatus(authFetch, recentRowsLimit),
    intervalMs,
    deps: [recentRowsLimit],
  });
}
